import { IconDefinition } from "./types";

const search: IconDefinition = {
  iconName: "search",
  width: 576,
  height: 512,
  svgPathData:
    "M400.4 208a160 160 0 1 0 -320 0 160 160 0 1 0 320 0zM369.6 371.1c-35.5 28.1-80.3 44.9-129.1 44.9-114.9 0-208-93.1-208-208s93.1-208 208-208 208 93.1 208 208c0 48.8-16.8 93.7-44.9 129.1l133.9 133.9 17 17-33.9 33.9-17-17-133.9-133.9z",
  iconType: "fill",
  fontAwesomeName: "magnifying-glass",
  unicode: 0xf002,
};

export { search };
